<template>
  <CustomUpdateDialog
    dialogTitle="ویرایش تایم کار در منزل"
    :dialogId="`update-homework-time-dialog-${dialogId}`"
    :isOkDisabled="isOkButtonDisabled"
    @ok="sendCreateTimeForHomeworkRequest"
  >
    <template v-if="defaultHomeworkTime">
      <BCol cols="12">
        <CustomDatePicker
          readonly
          inputId="homeworkTimePayloadDate"
          @getSelectedDate="setHomeworkPayloadDate"
          inputLabel="تاریخ زمان کار در منزل"
          inputPlaceholder="1403/06/05"
          v-model="homeworkTimePayload.date"
        ></CustomDatePicker>
      </BCol>
      <BCol cols="12">
        <CustomAppendText
          type="number"
          inputmode="numeric"
          isText
          customRules="required|min:1"
          inputId="homeworkTimePayloadTime"
          inputLabel="مدت زمان بازه"
          inputPlaceholder="10"
          v-model="homeworkTimePayload.masterTimeByMinute"
        >
          <template #append> دقیقه </template>
        </CustomAppendText>
      </BCol>
      <BCol cols="12">
        <TextInput
          inputId="homeworkDescription"
          inputLabel="توضیحات"
          inputPlaceholder="این زمان..."
          v-model="homeworkTimePayload.description"
        ></TextInput>
      </BCol>
    </template>
  </CustomUpdateDialog>
</template>
<script>
export default {
  emits: ["refetch"],
  props: {
    defaultHomeworkTime: {
      type: Object,
    },
    dialogId: {
      type: [String, Number],
    },
  },
  watch: {
    defaultHomeworkTime: {
      handler(val) {
        if (val) {
          this.homeworkTimePayload = JSON.parse(
            JSON.stringify(this.defaultHomeworkTime)
          );
        }
      },
      immediate: true,
    },
  },
  data() {
    return {
      homeworkTimePayload: {
        masterUserId: null,
        date: null,
        masterTimeByMinute: 0,
        description: null,
      },
      isOkButtonDisabled: false,
    };
  },
  methods: {
    setHomeworkPayloadDate(homeworkDate) {
      if (homeworkDate) {
        this.homeworkTimePayload.date = new Date(homeworkDate).toISOString();
      } else {
        this.homeworkTimePayload.date = null;
      }
    },
    async sendCreateTimeForHomeworkRequest() {
      try {
        this.isOkButtonDisabled = true;
        this.homeworkTimePayload.masterHomeWorkId = this.homeworkTimePayload.id;
        let _this = this;
        let updateAMasterHomework = new UpdateAMasterHomework(_this);
        updateAMasterHomework.setRequestParamDataObj(_this.homeworkTimePayload);
        await updateAMasterHomework.fetch((res) => {
          if (res.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "ویرایش شد!",
                icon: "CheckIcon",
                variant: "success",
                text: "زمان کار در منزل با موفقیت ویرایش شد.",
              },
            });
            _this.homeworkTimePayload = {
              masterUserId: null,
              date: null,
              masterTimeByMinute: 0,
              description: null,
            };
            this.$bvModal.hide(`update-homework-time-dialog-${this.dialogId}`);
            _this.$emit("refetch");
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "ویرایش نشد!",
                icon: "XIcon",
                variant: "danger",
                text: res.errors || "مشکلی پیش آمد، لطفا دوباره امتحان کنید",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isOkButtonDisabled = false;
      }
    },
  },
  components: {
    CustomUpdateDialog,
    CustomDatePicker,
    CustomAppendText,
    TextInput,
    BCol,
  },
};
import CustomUpdateDialog from "@/views/components/Utils/Dialogs/CustomUpdateDialog.vue";
import CustomDatePicker from "@/views/components/Utils/CustomDatePicker.vue";
import CustomAppendText from "@/views/components/Utils/CustomAppendText.vue";
import TextInput from "@/views/components/Utils/TextInput.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import { BCol } from "bootstrap-vue";
import { UpdateAMasterHomework } from "@/libs/Api/HomeWorks";
</script>
